import React from 'react';
import classNames from 'classnames';
import styles from './styles.scss';
import { Text } from '@towersystems/towersystems-design-system';

const Name = (value) =>
    value.split('#').map(function (name, index) {
          return (index==1 ? <span key={index}>{ name.split('-').join(' ').toUpperCase() } </span> : ''); 
      });


const AddOnName = ({ value, className, ...rest }) => {
    return (
        <Text weight='small' size='small' className={classNames(['plan-name', className])}  {...rest}>
            {Name(value)}
        </Text>
    );
};

export default AddOnName;
